<template>
  <v-select class="w-full" 
    v-model="operador" 
    :options="operadores" 
    label="nombre"
    @input="changeOperador"
    placeholder="Seleccione operador"
    :disabled="disabled"
    :reduce="id => id.id" 
  />
</template>

<script>
import vSelect from 'vue-select'
import commonComponentsStore from '@/store/common-components/index.js'

export default {
  components: {
    'v-select': vSelect
  },
  props: {
    operadorSelected: String,
    disabled: Boolean
  },
  data () {
    return {
      operador: (this.operadorSelected !== null && this.operadorSelected !== undefined) ? JSON.parse(JSON.stringify(this.operadorSelected)) : null,
      operadores: []
    }
  },
  methods: {
    changeOperador () {
      this.$emit('input', this.operador)
    }
  },
  async created () {
    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }
    this.operadores = this.$store.state.commonComponentsStore.operadores
  }
}
</script>

<style>

</style>